/**
 * Created by Дмитрий on 12.03.2019.
 */
import Api from './api';

class SphinxCatalog {
    api = new Api();
    
    getItemsByText(searchText) {
        return this.api.post('/catalog/default/search-catalog-items', {
            searchText: searchText
        });
    }

    search(searchText) {
        return this.getItemsByText(searchText);
    }
}

export default new SphinxCatalog();